export default {
  'Reviews.title': 'Reviews',
  'Reviews.search': 'Search',
  'Reviews.noData': "You haven't added any products yet",
}
